import backbone from 'backbone';
import { lastNDate } from '@bingads-webui-universal/primitive-utilities';
import { scopeOptions, emailOptions } from './options';
import { dataDateRanges, frequencyGrains } from './cron-selection/options';

export class RuleAuthoringModel extends backbone.Model {
  /**
   * Initialize model settings
   * @param {Object} param - An object containing these default options for model
   * @param {Object} param.odata - odata module
   * @param {string} param.odata.jq_ajax_adapter - the function for ajax action
   *
   * @returns {void} void
   */
  initialize({ odata }) {
    this.options = { odata };

    super.initialize(this.options);
    this.idAttribute = 'id';
  }


  /**
   * Default settings for the model
   *
   * @returns {void} void
   */
  defaults() {
    return {
      Id: null,
      Selection: '',
      Description: '',
      PreviewEntityIds: [],
      selectedEntityCount: 0,
      TotalRowCount: 0,
      BulkEditResults: [],
      SelectedRule: {
        id: null,
        entity: null,
        action: null,
        name: null,
        modifiedBy: {
          id: 0,
          name: '',
        },
        frequencyGrain: frequencyGrains.Daily,
        monthlyOption: '1',
        weeklyOption: '1',
        dailyOption: new Date().getHours(),
        runOnceDate: lastNDate(new Date(), -1),
        timeZoneOption: 0,
        dateRangePreset: dataDateRanges.Yesterday,
        emailOption: emailOptions.EveryTimeThisRuleRuns,
        scopeInfo: {
          allPages: false,
          selectedRowCount: 0,
          selectedRowIds: null,
          campaignId: null,
          adGroupId: null,
        },
        scopeOption: scopeOptions.AllButRemoved,
        filter: {
          Name: '',
          Id: '',
          FilterExpressions: [],
        },
        nonTextAction: {},
      },
    };
  }

  parse(response) {
    if (response) {
      return {
        Id: response.value,
        TotalRowCount: response.TotalRowCount,
        BulkEditResults: response.BulkEditResults,
      };
    }

    return null;
  }

  sync(method, model, options) {
    if (model.isSimulation) {
      options.type = 'Post'; // eslint-disable-line  no-param-reassign
      options.data = JSON.stringify({ // eslint-disable-line  no-param-reassign
        Entity: model.get('Entity'),
        BatchAction: model.get('BatchAction'),
        Selection: model.get('Selection'),
        Description: model.get('Description'),
        PreviewEntityIds: model.get('PreviewEntityIds'),
        CurrentCustomerId: model.get('CurrentCustomerId'),
      });
    } else if (method === 'create') {
      if (model.isEditRule === true) {
        options.type = 'Patch'; // eslint-disable-line  no-param-reassign
      } else {
        options.type = 'Post'; // eslint-disable-line  no-param-reassign
      }
      options.data = JSON.stringify({ // eslint-disable-line  no-param-reassign
        '@odata.type': '#Model.AdvertiserRule',
        Type: 'AdvertiserSearch',
        NotificationMedium: 'Email',
        Entity: model.get('Entity'),
        BatchAction: model.get('BatchAction'),
        Selection: model.get('Selection'),
        Description: model.get('Description'),
        Name: model.get('Name'),
        NotificationType: model.get('NotificationType'),
        TimeZoneId: model.get('TimeZoneId'),
        Cron: model.get('Cron'),
        CurrentCustomerId: model.get('CurrentCustomerId'),
      });
    } else {
      options.type = 'Get'; // eslint-disable-line  no-param-reassign
    }
    return this.options.odata.jq_ajax_adapter.call(this, this.url, options);
  }
}
